import createModule from './base';
import lodash from 'lodash';
const _ = require('deepdash')(lodash);

export default createModule({
  idField: 'groupID',
  getters: {
    divisions: (state, getters) => getters.flatTree(30),
    organizations: (state, getters) => getters.flatTree(20),
    flatTree: (state, getters) => (roleID = -1, orgID = -1) => {
      //console.log(orgID);
      _.mixin({
        flatTree: (obj, level = 0, prefix = '&nbsp;&nbsp;') =>
          _.flatMapDeep(obj, elem => {
            const el = {
              ..._.omit(elem, 'children'),
              name: `${prefix.repeat(level)} ${elem.name}`
            };
            return _.isEmpty(elem.children)
              ? [el]
              : [el, _.flatTree(elem.children, level + 1)];
          })
      });
      return _.flatTree(getters.tree(roleID, orgID));
    },
    tree: (state, getters, rootState, rootGetters) => (
      roleID = -1,
      orgID = -1
    ) => {
      const groupedUsers = _.chain(rootGetters['users/list'])
        .flatMap(user => user.roles.map(role => ({ ...user, roles: role })))
        .groupBy('roles.groupID')
        .value();

      let organizationLevel = '';
      switch (roleID) {
        case 10: // UEG ADMIN
          organizationLevel = 'Organization';
          break;
        case 20: // Organization ADMIN
          organizationLevel = 'Organization';
          break;
        case 30: // Division ADMIN
          organizationLevel = 'Division';
          break;
        case 40: // WG admin
        case 50: // Individual user
          organizationLevel = 'Workgroup';
          break;
      }

      const organizationLevelValues = {
        Organization: 20,
        Division: 30,
        Workgroup: 40,
        '': 40
      };
      const keyed = _(state._items)
        /**
         * elimina a chave dos projectos,
         * adiciona o campo do organizationLevel em numerico e
         * decide se está disabled ou nao
         */
        .map(i => {
          return {
            ..._.omit(i, ['projects']),
            organizationLevelValue:
              organizationLevelValues[i.organizationLevel],
            disabled:
              !(
                organizationLevel == '' ||
                i.organizationLevel == organizationLevel
              ) && roleID != 50,
            users: groupedUsers[i.groupID] || []
          };
        })
        /**
         * filtra todos os elementos que sao abaixo do nivel selecionado
         */
        .filter(i => {
          if (orgID != -1) {
            return (
              i.organizationID == orgID &&
              organizationLevelValues[i.organizationLevel] <=
                organizationLevelValues[organizationLevel]
            );
          } else {
            return (
              organizationLevelValues[i.organizationLevel] <=
              organizationLevelValues[organizationLevel]
            );
          }
        })
        .keyBy('groupID')
        .value();
      const output = [];
      _.forEach(keyed, function(value, key) {
        const parentGroupID = value.parentGroupID;
        if (_.has(keyed, parentGroupID)) {
          (
            keyed[parentGroupID].children ||
            (keyed[parentGroupID].children = [])
          ).push(keyed[key]);
        } else {
          output.push(keyed[key]);
        }
      });
      return output;
    },
    list: (state, getters) => {
      return _.chain(getters.tree())
        .filter({ organizationLevel: 'Organization' })
        .flatMap('children')
        .value();
    },
    items: state => {
      return state._items;
    }
  }
});
